"use strict";

exports.__esModule = true;
exports.extractHashtagsFromContent = exports.extractHashtagsFromText = void 0;

var _lodash = require("lodash");

var _hashtagRegexes = _interopRequireDefault(require("./hashtag-regexes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function extractHashtags(text) {
  if (!text || !text.match(_hashtagRegexes["default"].hashSigns)) {
    return [];
  }

  var tags = []; //eslint-disable-next-line max-params

  text.replace(_hashtagRegexes["default"].validHashtag, function (match, before, hash, hashText, offset, chunk) {
    var after = chunk.slice(offset + match.length);

    if (after.match(_hashtagRegexes["default"].endHashtagMatch)) {
      return;
    }

    var startPosition = offset + before.length;
    var endPosition = startPosition + hashText.length + 1;
    tags.push({
      hashtag: hashText,
      indices: [startPosition, endPosition]
    });
  });
  return tags;
}

var getContentText = function getContentText(content) {
  return (0, _lodash.chain)(content).get('blocks', []).filter(function (block) {
    return block.type !== 'code-block';
  }).map(function (block) {
    return (0, _lodash.trim)(block.text);
  }).filter(_lodash.identity).join(' ').value();
};

var mapHashtags = function mapHashtags(hashtags) {
  return (0, _lodash.map)(hashtags, function (hashtagData) {
    return hashtagData.hashtag;
  });
};

var mapToLowerCase = function mapToLowerCase(hashtags) {
  return (0, _lodash.map)(hashtags, function (hashtag) {
    return hashtag.toLowerCase();
  });
};

var extractHashtagsFromText = (0, _lodash.flowRight)(_lodash.uniq, mapToLowerCase, mapHashtags, extractHashtags, _lodash.toString);
exports.extractHashtagsFromText = extractHashtagsFromText;
var extractHashtagsFromContent = (0, _lodash.flowRight)(_lodash.uniq, mapToLowerCase, mapHashtags, extractHashtags, getContentText);
exports.extractHashtagsFromContent = extractHashtagsFromContent;